import { render } from "./formPresupuesto.vue?vue&type=template&id=49b2c80e"
import script from "./formPresupuesto.vue?vue&type=script&lang=js"
export * from "./formPresupuesto.vue?vue&type=script&lang=js"

import exportComponent from "C:\\repos\\excurix\\src\\UI\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__